module.exports = __webpack_public_path__ + "img/tz.9f2e1626.png";